import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { PointsSummaryFacade } from '@features/points-summary/facades/points-summary-facade/points-summary.facade';
import { LoyaltyCurrencyFacade } from '@rd/core/facades/loyalty-currency-facade/loyalty-currency.facade';

type UserAction = 'logout' | 'changePassword';

@Component({
  selector: 'star-core-header-profile',
  templateUrl: './header-profile.component.html',
  styleUrls: ['./header-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StarHeaderProfileComponent {
  @Output() userActionEvent: EventEmitter<UserAction> =
    new EventEmitter<UserAction>();

  menuExpanded = false;

  constructor(
    public pointsSummaryFacade: PointsSummaryFacade,
    public loyaltyCurrencyFacade: LoyaltyCurrencyFacade,
  ) {}

  toggleMenu(): void {
    this.menuExpanded = !this.menuExpanded;
  }

  closeMenu(): void {
    this.menuExpanded = false;
  }
}
